package com.patronat.top.features.usermanagement.domain.usecase.command

import com.patronat.top.core.domain.models.profiles.UserFilter
import com.patronat.top.domain.usecase.Command

class GetFilteredUsersCommand(val userFilter: UserFilter): Command